module.exports = __webpack_public_path__ + "static/media/squats-lunges.e7f292f5.mov";